import React from "react";
import styled from "styled-components";
import { Spinner } from ".";
import { SIZE } from "baseui/spinner";
import { HiddenAccessibleSpan } from "../../../accessibility/hidden_accessible_span";

const LoadingContainer = styled.div`
  position: fixed;
  top: 50%;
  left: 50%;
`;

export const CenteredLoadingSpinner = () => {
  return (
    <LoadingContainer>
      <Spinner size={SIZE.large} />
      <HiddenAccessibleSpan>Loading</HiddenAccessibleSpan>
    </LoadingContainer>
  );
};
